import React, { useContext, useEffect, useState } from 'react'
import { deleteBeneficary, getListBeneficary, updateBeneficiary } from 'requests/benificary'
import UserContext from 'contexts/UserContext'
import { BeneficiaryType } from 'types/beneficiary'
import CardBeneficiary from './beneficiaireContainer/CardBeneficiary'
import NoBenef from '../assets/iconNoBenef.svg'
import FlecheRetour from '../assets/arrow-back-navigation.svg'
import { useNavigate } from 'react-router-dom'
import ModalUpdateBeneficiary from './beneficiaireContainer/ModalUpdateBeneficiary'
import ModalBeneficiaryServices from './beneficiaireContainer/ModalBeneficiaryServices'
import ModalAddBeneficiary from './beneficiaireContainer/modalAddBeneficiary'
import ModalDeleteBeneficiary from './beneficiaireContainer/modalDeleteBeneficiary'
import { Spinner } from 'utils/loading'

const Beneficiary = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [openModalAddbenef, setOpenModalAddBenef] = useState(false)
  const [listBeneficiary, setListBeneficiary] = useState<BeneficiaryType[]>()
  const [selectedBeneficiary, setSelectedBeneficiary] = useState<BeneficiaryType | null>(null)
  const { user } = useContext(UserContext)
  const [shouldRefreshBeneficiaries, setShouldRefreshBeneficiaries] = useState(false)
  const [action, setAction] = useState<'delete' | 'update' | 'service' | null>(null)
  const id = user?.user._id
  const token = user?.token?.accessToken
  const navigation = useNavigate()

  useEffect(() => {
    async function fetchData() {
      const response = await getListBeneficary(id, token)
      if (response.success) {
        setListBeneficiary(response.beneficiaries)
        setSelectedBeneficiary(null)
        setIsPageLoading(false)
      }
    }

    fetchData()
  }, [shouldRefreshBeneficiaries])

  const handleDelete = async () => {
    try {
      const response = await deleteBeneficary(id, token, selectedBeneficiary?._id)
      if (response.success) {
        setShouldRefreshBeneficiaries((prev) => !prev)
        setAction(null)
      }
    } catch (error) {
      console.log('error')
    }
  }

  const handleUpdate = async (values: any) => {
    setIsLoading(true)

    const data = {
      gender: values.gender,
      phonePrefix: values.phonePrefix,
      phoneNumber: values.phoneNumber,
      reason: values.relationship,
      language: 'FR',
      avatar: values.avatar,
      userId: id,
      beneficiaryId: selectedBeneficiary?._id,
      firstName: values.firstName,
      lastName: values.lastName,
      bankName: values.bankName,
      Iban: values.Iban,
      beneficiaryIdentifiant: values.beneficiaryIdentifiant,
      SWIFTBIC: values.SWIFTBIC,
      bankCode: values.bankCode,
    }
    try {
      const response = await updateBeneficiary(data, token)
      if (response.success) {
        setIsLoading(false)

        setShouldRefreshBeneficiaries((prev) => !prev)
        setAction(null)
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div className="flex flex-col  items-center ">
      <div className="flex w-full items-center lg:mt-[40px]">
        <button
          type="button"
          onClick={() => navigation('/')}
          className="hidden lg:block cursor-pointer"
          aria-label="Retour à la page précédente"
        >
          <img src={FlecheRetour} alt="" />
        </button>
        <h2 className=" h1 w-full">Mes Bénéficiaires</h2>
      </div>
      <button
        type="button"
        className=" mt-[50px] flex gap-2 items-center pr-2  justify-center text-white font-semibold text-[14px] bg-[#5754E5] w-[220px] h-[40px] rounded-xl "
        onClick={() => setOpenModalAddBenef(true)}
      >
        <span> + </span> Ajouter un bénéficiaire
      </button>

      <div className="flex flex-wrap justify-center gap-5 mt-[40px] ">
        {isPageLoading ? (
          <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" fadeIn="none" />
        ) : listBeneficiary && listBeneficiary?.length !== 0 ? (
          listBeneficiary.map((item: BeneficiaryType, index: number) => (
            <CardBeneficiary
              key={index}
              setAction={setAction}
              setSelectedBeneficiary={setSelectedBeneficiary}
              beneficiary={item}
            />
          ))
        ) : (
          <div className=" w-[210px] h-[330px]  border border-dashed rounded-[14px] flex flex-col gap-4 items-center justify-center">
            <img src={NoBenef} width={32} height={32} alt="Aucun bénéficiaire" />
            <p className="text-[#808091] text-center text-[10px]">
              Vous n&rsquo;avez pas encore ajouté <br />
              de bénéficiaire.
            </p>
          </div>
        )}
      </div>
      {openModalAddbenef && (
        <ModalAddBeneficiary setIsOpen={setOpenModalAddBenef} setIsBeneficiaryAdded={setShouldRefreshBeneficiaries} />
      )}
      {action === 'delete' && <ModalDeleteBeneficiary HandleDelete={handleDelete} setAction={setAction} />}
      {action === 'update' && (
        <ModalUpdateBeneficiary
          setSelectedBeneficiary={setSelectedBeneficiary}
          beneficiary={selectedBeneficiary}
          HandleUpdate={handleUpdate}
          setAction={setAction}
          val="update"
          isLoading={isLoading}
        />
      )}
      {action === 'service' && selectedBeneficiary && (
        <ModalBeneficiaryServices selectedBeneficiary={selectedBeneficiary} setAction={setAction} />
      )}
    </div>
  )
}

export default Beneficiary
